import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import { Hammer } from 'lucide-react';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { isProductionEnvironment, playgroundIds } from 'utils/environment';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const PlaygroundTabsHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  //Code commented for now, will be removed once OFD 2.0 reach prod.
  const {
    account: { currentUser },
  } = useAccountState();

  const userId = useMemo(() => currentUser?.id || '', [currentUser]);
  /*
  const history = useHistory();
  useEffect(() => {
    if (isProductionEnvironment) history.push('/overview'); // kick users out if they somehow get to a component that renders the tabs header. Prob unnecessary since routes are not added if in production, so nothing in this feature is reachable
  }, []);
  */

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: playgroundIds.includes(userId) || !isProductionEnvironment,
          label: 'Playground',
          to: '/playground/info',
        },
        {
          hasAccess: playgroundIds.includes(userId) || !isProductionEnvironment,
          label: 'Palette',
          to: '/playground/palette',
        },
        {
          hasAccess: playgroundIds.includes(userId) || !isProductionEnvironment,
          label: 'My Supply Plan',
          to: '/playground/supply-plan',
        },
        {
          hasAccess: playgroundIds.includes(userId) || !isProductionEnvironment,
          label: 'BluViu Nutrition R2',
          to: '/playground/bluviu-nutrition-r2',
        },
        {
          hasAccess: playgroundIds.includes(userId) || !isProductionEnvironment,
          label: 'Data Lab',
          to: '/playground/data-lab',
        },
      ]}
      icon={
        <Link to={'/playground'} className="playground-hammer-icon-link">
          <Hammer size={25} color={'white'} />
        </Link>
      }
      intro={intro}
      actions={actions}
      utils={utils}
    />
  );
};

export default React.memo(PlaygroundTabsHeader);
